export default __webpack_public_path__ + "static/media/next-disabled.482df752.png";